// extracted by mini-css-extract-plugin
module.exports = {"subBanner":"subBanner--26Maz","mainWidth":"mainWidth--3JNWI","textWrap":"textWrap--1MlTM","title":"title--1wW6M","subtitle":"subtitle--3hoYu","imageWrap":"imageWrap--3ueQx"};